import styles from './page.module.css';
import { brand } from '@/brand/brand';

export default function Page({ children }) {
  const pageStyle = brand.internalBackgroundImage ? {
    backgroundImage: `url(${brand.internalBackgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
  } : {};

  return (
    <section className={styles.page} style={pageStyle}>
      <main className={styles.content}>{children}</main>
    </section>
  );
}
